import {reportsService} from '../../services/service-factory';

export default {
  data: function() {
    return {
      reportsService: undefined
    };
  },
  created: function() {
    this.reportsService = reportsService;
  }
};
